import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

// Sends a GA4 page_view on every client-side route change. Mount once inside
// <Router>. The initial page_view is fired by gtag('config') in index.html; this
// covers all subsequent SPA navigations so they don't depend on the GA4
// Enhanced Measurement "page changes based on browser history events" setting.
// Renders nothing.
export default function AnalyticsListener() {
  // useLocation() reports the path with the Router's `basename` stripped (e.g.
  // "/trendline-iq" even when the visitor is on "/de/trendline-iq"), because
  // that's the un-prefixed path app code (Nav.js active-link checks, etc.)
  // wants. But GA4 page_path needs the REAL, locale-prefixed URL — otherwise
  // German and English pageviews collapse onto the same path in every report,
  // defeating the whole point of localized analytics. So we still depend on
  // pathname/search here to re-trigger the effect on every client-side
  // navigation, but we read the actual path from window.location instead of
  // the (locale-stripped) values React Router gives us. Do not "simplify"
  // this back to the destructured pathname/search — that regresses locale
  // reporting silently.
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Defer a tick so the new route has committed and document.title is current.
    const id = window.setTimeout(() => {
      trackPageView({
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    }, 0);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
}
